var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationFilled = function SvgLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5C4.313.5.5 4.313.5 9c0 2.018.724 3.976 2.046 5.524.151.171 3.714 4.22 4.904 5.354a2.239 2.239 0 0 0 3.1 0c1.384-1.32 4.762-5.193 4.91-5.363A8.499 8.499 0 0 0 17.5 9C17.5 4.313 13.687.5 9 .5Zm0 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: "gray"
  })));
};

export default SvgLocationFilled;